export interface Fact {
  value: string;
  label: string;
}

export const defaultFacts: Fact[] = [
  { value: "Since", label: "2013" },
  { value: "Licensed", label: "CE64623" },
  { value: "Master Electrician", label: "ME64500" },
  { value: "HVAC Master", label: "HM06538" },
  { value: "24/7", label: "Emergency" },
  { value: "1-Year", label: "Warranty" },
];

/**
 * 64px fact strip — value/label pairs on white, thin dividers, no icons.
 * Replaces the old four-tile StatBlock on inner pages.
 */
const FactStrip = ({ facts }: { facts: Fact[] }) => (
  <div data-fact-strip className="border-y border-border bg-card">
    <div className="container">
      <div className="flex h-16 items-center gap-6 overflow-x-auto whitespace-nowrap">
        {facts.map((f, i) => (
          <div
            key={`${f.value}-${f.label}`}
            className={`flex items-baseline gap-2 pr-6 ${i < facts.length - 1 ? "border-r border-border" : ""}`}
          >
            <span className="font-heading text-[16px] font-bold text-foreground">{f.value}</span>
            <span className="font-body text-[14px] text-muted-foreground">{f.label}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default FactStrip;
